<template>
  <div class="product-detail">
    <div class="product-detail-box">
      <div class="product-detail-title">
        <img :src="url">
        <div class="info">
          <div class="info-title">{{ $t('productCenter.tabs.nanoBoard') }}</div>
          <div class="info-text">{{ productDescription }}</div>
          <el-button 
            style="height: 43px;"
            type="primary" 
            @mouseenter.native="mouseenter" 
            @mouseleave.native="mouseleave"
          >
            {{ btnText }}
            <img 
              v-if="showcloudDownloadImg" 
              style="margin-right: 0;height: 15px;position: relative;top: 2px;" 
              :src="cloudDownload"
            >
          </el-button>
        </div>
      </div>
    </div>
    <div class="product-detail-info">

      <div class="table">
        <el-table
          :data="tableData"
          stripe
          border
          style="width: 100%">
            <el-table-column
              prop="project"
              :label="$t('productCenter.common.project')"
              width="240">
              <template slot-scope="scope">
                <div style="padding-left: 10px;">
                  <span class="multiline">{{ scope.row.project.replace(/｜/g, '\n') }}</span>
                </div>
              </template>
            </el-table-column>
            <el-table-column
              prop="test"
              :label="$t('productCenter.product12.tableHeaders.unit')"
              align="center"
              width="154">
              <template slot-scope="scope">
                <template v-if="scope.row.test.includes('｜')">
                  <div :class="`current${idx}`" v-for="(line, idx) in scope.row.test.split('｜')" :key="idx">
                    {{ line }}
                  </div>
                </template>
                <template v-else>
                  {{ scope.row.test }}
                </template>
              </template>
            </el-table-column>
            <el-table-column
              prop="parameter1"
              align="center"
              width="154"
              label="PAS-10">
              <template slot-scope="scope">
                <template v-if="scope.row.parameter1.includes('｜')">
                  <div :class="`current${idx}`" v-for="(line, idx) in scope.row.parameter1.split('｜')" :key="idx">
                    {{ line }}
                  </div>
                </template>
                <template v-else>
                  {{ scope.row.parameter1 }}
                </template>
              </template>
            </el-table-column>
            <el-table-column
              prop="parameter2"
              align="center"
              width="154"
              label="PAS-20">
              <template slot-scope="scope">
                <template v-if="scope.row.parameter2.includes('｜')">
                  <div :class="`current${idx}`" v-for="(line, idx) in scope.row.parameter2.split('｜')" :key="idx">
                    {{ line }}
                  </div>
                </template>
                <template v-else>
                  {{ scope.row.parameter2 }}
                </template>
              </template>
            </el-table-column>
            <el-table-column
              prop="parameter3"
              align="center"
              width="154"
              label="PAS-30">
              <template slot-scope="scope">
                <template v-if="scope.row.parameter3.includes('｜')">
                  <div :class="`current${idx}`" v-for="(line, idx) in scope.row.parameter3.split('｜')" :key="idx">
                    {{ line }}
                  </div>
                </template>
                <template v-else>
                  {{ scope.row.parameter3 }}
                </template>
              </template>
            </el-table-column>
            <el-table-column
              prop="parameter4"
              align="center"
              width="154"
              label="PAS-40">
              <template slot-scope="scope">
                <template v-if="scope.row.parameter4.includes('｜')">
                  <div :class="`current${idx}`" v-for="(line, idx) in scope.row.parameter4.split('｜')" :key="idx">
                    {{ line }}
                  </div>
                </template>
                <template v-else>
                  {{ scope.row.parameter4 }}
                </template>
              </template>
            </el-table-column>
            <el-table-column
              prop="parameter5"
              align="center"
              width="188"
              :label="$t('productCenter.product12.tableHeaders.testStandard')">
            </el-table-column>
        </el-table>
      </div>

      <div class="product-features">
        <div class="product-left">
          <div class="title">{{ $t('productCenter.product12.productFeaturesTitle') }}</div>
          <div class="info" v-html="$t('productCenter.product12.productFeaturesIntro')"></div>
          <div class="text1" v-for="(feature, index) in productFeatures" :key="index">
            <span></span>
            <p>{{ feature }}</p>
          </div>
          <div class="tips">{{ $t('productCenter.product12.productFeaturesTip') }}</div>
        </div>
        <div class="product-right">
          <img :src="product12_1">
          <img :src="product12_2">
        </div>
      </div>

      <div class="product-detail-chart">
        <div class="chart-title">{{ $t('productCenter.product12.productDetailTitle') }}</div>
        <div class="chart-list">
          <div class="chart-item" v-for="(item, index) in productDetailItems" :key="index" :class="{ 'current': index === 3 }">
            
            <template v-if="$i18n.locale == 'zh'">
              <img v-if="index === 0" :src="productChart1">
              <img v-if="index === 1" :src="productChart2">
              <img v-if="index === 2" :src="productChart3">
            </template>

            <template v-if="$i18n.locale == 'en'">
              <img v-if="index === 0" :src="productChart4">
              <img v-if="index === 1" :src="productChart5">
              <img v-if="index === 2" :src="productChart6">
            </template>

            <template v-if="$i18n.locale == 'de'">
              <img v-if="index === 0" :src="productChart7">
              <img v-if="index === 1" :src="productChart8">
              <img v-if="index === 2" :src="productChart9">
            </template>

            <template v-if="index === 3">
              <el-table
                :data="tableDataChart"
                stripe
                border
                style="width: 100%">
                  <el-table-column
                    prop="project"
                    :label="$t('productCenter.product12.tableHeaders.strain')"
                    width="95">
                  </el-table-column>
                  <el-table-column
                    prop="test"
                    label="10.56"
                    align="center"
                    width="95">
                  </el-table-column>
                  <el-table-column
                    prop="parameter1"
                    align="center"
                    width="95"
                    label="17.15">
                  </el-table-column>
                  <el-table-column
                    prop="parameter2"
                    align="center"
                    width="94"
                    label="22.01">
                  </el-table-column>
                  <el-table-column
                    prop="parameter3"
                    align="center"
                    width="90"
                    label="26.3">
                  </el-table-column>
                  <el-table-column
                    prop="parameter4"
                    align="center"
                    width="90"  
                    label="30.27">
                  </el-table-column>
              </el-table>
            </template>
            
            <span v-if="index < 2">{{ item }}</span>
            <div v-if="index === 3" class="chart-annotation">{{ item }}</div>
          </div>
        </div>
      </div>

      <div class="aging-tips">{{ $t('productCenter.product12.agingTips') }}</div>

      <el-table class="table" :data="tableData2" style="margin-top: 24px;padding-top: 0;" border stripe>
        <el-table-column :label="$t('productCenter.product12.tableHeaders.agingCondition')" prop="project" align="center"></el-table-column>
        <el-table-column :label="$t('productCenter.product12.tableHeaders.testTemperature')" prop="test" align="center"></el-table-column>
        <el-table-column :label="$t('productCenter.product12.tableHeaders.thermalConductivity')" prop="parameter1" align="center"></el-table-column>
      </el-table>

      <el-table class="customTable" :data="tableData3" style="margin-top: 24px;" border stripe>
        <el-table-column :label="$t('productCenter.product12.tableHeaders.insulationTest')">
          <el-table-column prop="project" align="center"></el-table-column>
          <el-table-column prop="test" align="center"></el-table-column>
          <el-table-column prop="parameter1" align="center"></el-table-column>
          <el-table-column prop="parameter2" align="center"></el-table-column>  
          <el-table-column prop="parameter3" align="center"></el-table-column>  
        </el-table-column>
      </el-table>

      <el-table class="customTable" :data="tableData4" style="margin-top: 24px;" border stripe>
        <el-table-column :label="$t('productCenter.product12.tableHeaders.coldSideTemp')">
          <el-table-column prop="project" align="center"></el-table-column>
          <el-table-column prop="test" align="center"></el-table-column>
          <el-table-column prop="parameter1" align="center"></el-table-column>
          <el-table-column prop="parameter2" align="center"></el-table-column>  
          <el-table-column prop="parameter3" align="center"></el-table-column>  
        </el-table-column>
      </el-table>

      <el-table class="customTable" :data="tableData5" style="margin-top: 24px;" border stripe>
        <el-table-column :label="$t('productCenter.product12.tableHeaders.voltageTest')">
          <el-table-column prop="project" align="center"></el-table-column>
          <el-table-column prop="test" align="center"></el-table-column>
          <el-table-column prop="parameter1" align="center"></el-table-column>
          <el-table-column prop="parameter2" align="center"></el-table-column>  
          <el-table-column prop="parameter3" align="center"></el-table-column>  
        </el-table-column>
      </el-table>

      <el-table class="customTable" :data="tableData6" style="margin-top: 24px;" border stripe>
        <el-table-column :label="$t('productCenter.product12.tableHeaders.compressionTest')">
          <el-table-column prop="project" align="center"></el-table-column>
          <el-table-column prop="test" align="center"></el-table-column>
          <el-table-column prop="parameter1" align="center"></el-table-column>
          <el-table-column prop="parameter2" align="center"></el-table-column>  
        </el-table-column>
      </el-table>

      <div class="bottom-tips">{{ $t('productCenter.product12.bottomTips') }}</div>

    </div>
  </div>
</template>

<script>
export default {
  data () {
    return {
      url: require('@/assets/images/productCenter/product12.png'),
      cloudDownload: require('@/assets/images/cloud-download.png'),
      product12_1: require('@/assets/images/productCenter/product12_1.png'),
      product12_2: require('@/assets/images/productCenter/product12_2.png'),
      productChart1: require('@/assets/images/productCenter/product_chart_1.png'),
      productChart2: require('@/assets/images/productCenter/product_chart_2.png'),  
      productChart3: require('@/assets/images/productCenter/product_chart_3.png'),
      productChart4: require('@/assets/images/productCenter/product_chart_4.png'),
      productChart5: require('@/assets/images/productCenter/product_chart_5.png'),  
      productChart6: require('@/assets/images/productCenter/product_chart_6.png'),
      productChart7: require('@/assets/images/productCenter/product_chart_7.png'),
      productChart8: require('@/assets/images/productCenter/product_chart_8.png'),  
      productChart9: require('@/assets/images/productCenter/product_chart_9.png'),


      showcloudDownloadImg: true
    }
  },
  computed: {
    productDescription () {
      return this.$t('productCenter.product12.description')
    },
    btnText () {
      return this.showcloudDownloadImg 
        ? this.$t('productCenter.downloadManual')
        : this.$t('productCenter.contactForMore')
    },
    productFeatures () {
      return this.$t('productCenter.product12.productFeatures')
    },
    productDetailItems () {
      return this.$t('productCenter.product12.productDetailItems')
    },
    tableData () {
      const data = this.$t('productCenter.product12.tableData')
      return data.map(item => ({
        project: item.project,
        test: item.test,
        parameter1: item.parameter1,
        parameter2: item.parameter2,
        parameter3: item.parameter3,
        parameter4: item.parameter4,
        parameter5: item.parameter5
      }))
    },
    tableDataChart () {
      return this.$t('productCenter.product12.tableDataChart')
    },
    tableData2 () {
      return this.$t('productCenter.product12.tableData2')
    },
    tableData3 () {
      return this.$t('productCenter.product12.tableData3')
    },
    tableData4 () {
      return this.$t('productCenter.product12.tableData4')
    },
    tableData5 () {
      return this.$t('productCenter.product12.tableData5')
    },
    tableData6 () {
      return this.$t('productCenter.product12.tableData6')
    }
  },
  methods: {
    mouseenter () {
      this.showcloudDownloadImg = false
    },
    mouseleave () {
      this.showcloudDownloadImg = true
    }
  }
}
</script>

<style lang="scss" scoped>
.product-detail {

  .bottom-tips {
    font-weight: 400;
    font-size: 18px;
    color: rgba(43,50,71,0.7);
    padding-top: 20px;
  }

  .customTable {
    ::v-deep thead tr:last-child {
      display: none;
    }

    ::v-deep .is-group.has-gutter {
      .cell {
        color: #333;
        text-align: center;
      }
    }
  }

  .aging-tips {
    font-weight: 400;
    font-size: 18px;
    color: rgba(43,50,71,0.7);
  }

  .product-detail-chart {

    .chart-title {
      font-weight: 500;
      font-size: 32px;
      color: #2B3247;
      padding-bottom: 40px;
    }

    .chart-list {
      display: flex;
      flex-wrap: wrap;
      justify-content: space-between;

      .chart-item {
        width: 560px;
        padding-bottom: 60px;

        span {
          padding-top: 40px;
          display: block;
          font-weight: 400;
          font-size: 18px;
          color: rgba(43,50,71,0.7);
        }

        .chart-annotation {
          font-weight: 400;
          font-size: 18px;
          color: rgba(43,50,71,0.7);
          padding-top: 40px;
        }

        &.current {
          padding-top: 70px;
        }
      }
    }
  }

  .product-features {
    display: flex;
    padding: 40px 0 80px;

    .product-left {
      width: 55%;
      padding-right: 20px;

      .title {
        font-weight: 500;
        font-size: 24px;
        color: #2B3247;
        padding-bottom: 24px;
      }

      .info {
        font-weight: 500;
        font-size: 18px;
        color: #2B3247;
        text-align: left;
        padding-bottom: 24px;
      }

      .text1 {
        display: flex;
        padding-bottom: 24px;
        span {
          position: relative;
          top: 10px;
          flex-shrink: 0;
          display: inline-block;
          width: 4px;
          height: 4px;
          border-radius: 50%;
          background-color: rgba(43, 50, 71, 0.7);
          margin-right: 8px;
        }

        p {
          font-weight: 400;
          font-size: 18px;
          color: rgba(43,50,71,0.7);
        }
      }

      .tips {
        font-weight: 500;
        font-size: 18px;
        color: #2B3247;
      }
    }
    
    .product-right {
      padding-top: 60px;
      width: 45%;

      img {
        &:first-child {
          margin-right: 54px;
        }
      }
    }
  }

  .product-detail-box {
    padding: 60px 0;
    background: rgb(248, 250, 253);
  }

  .product-detail-title {
    width: 1200px;
    margin: 0 auto;
    display: flex;
    img {
      margin-right: 40px;
    }
    .info {
      .info-title {
        font-weight: 500;
        font-size: 24px;
        line-height: 34px;
        padding-bottom: 30px;
      }
      .info-text {
        font-weight: 400;
        font-size: 18px;
        line-height: 25px;
        color: rgba(43, 50, 71, 0.7);
        padding-bottom: 30px;
      }
      .el-button {
        background-color: #fff;
        color: rgb(28, 100, 215);
        border-color: rgb(28, 100, 215);
        i {
          display: inline-block;
        }
      }
    }
  }

  .product-detail-info {
    width: 1200px;
    margin: 0 auto;
    padding: 0 0 100px;

    .table {
      padding-top: 60px;
      ::v-deep .el-table .cell {
        padding: 0;
        div {
          &:last-child {
            padding-bottom: 0;
            border-bottom: 0;
          }
        }
      }
      .current0 {
        padding-bottom: 10px;
        border-bottom: 1px solid #EBEEF5;
      }
      .current1, .current2, .current3, .current4 {
        padding: 10px 0;
        border-bottom: 1px solid #EBEEF5;
      }
      .current5 {
        padding-top: 10px;
      }
      ::v-deep .el-table__header th {
        background-color: #f5f7fa;
        text-align: center;
        color: rgb(43, 50, 71);
      }
      ::v-deep .el-table--striped .el-table__body tr.el-table__row--striped td.el-table__cell {
        background-color: #f5f7fa;
      }
      ::v-deep .el-table__body td {
        color: rgba(43, 50, 71, 0.7);
      }
      .multiline {
        white-space: pre-line;
        color: rgb(43, 50, 71);
        font-weight: 500;
      }
    }
  }
}
</style>
